









import {
    Vue, Component, Prop, Mixins, Watch, PropSync,
} from 'vue-property-decorator'
import {State, Getter} from 'vuex-class'
import util from '@/util'
import common from '@/common'
import validate from '@/common/validate'
import api from '@/api'

@Component({
    components: {
    },
})
export default class CompanyIcon extends Vue {
    @Prop() type!: string
}
